import { Api } from '@/api';
import type { ContactStage } from '@/api/entity_types/Contact';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner';
import { computed, type Ref } from 'vue';
import { toast } from 'vue-sonner';

const stageOptions: ContactStage[] = ['Applied', 'Phone Screen', 'Interview', 'Onboarding', 'Hired', 'Nurture'];

const stageTransitions: Partial<Record<ContactStage, ContactStage>> = {
  Unlicensed: 'Phone Screen',
  'Unlicensed with Coursework Started': 'Phone Screen',
  Applied: 'Phone Screen',
  'Phone Screen': 'Interview',
  Nurture: 'Interview',
  Interview: 'Onboarding',
  Onboarding: 'Hired',
};

export type UseMoveContactStageReturn = ReturnType<typeof useMoveContactStage>;

export const useMoveContactStage = (contact: Ref<{ id: number; stage: ContactStage }>) => {
  const loadingSpinnerStore = useLoadingSpinnerStore();
  const nextStage = computed(() => stageTransitions[contact.value.stage]);

  const updateContactStage = async (stage: ContactStage): Promise<boolean> => {
    loadingSpinnerStore.showLocalLoadingSpinner();
    const response = await Api.Contacts.updateContact({ contactId: contact.value.id, payload: { stage } });
    loadingSpinnerStore.hideLocalLoadingSpinner();

    if (response.status !== 'error') {
      toast.success('Candidate stage updated', { description: "Your candidate's stage was successfully updated" });
      return true;
    } else {
      toast.error('Candidate stage error', { description: response.message });
      return false;
    }
  };

  return { nextStage, stageOptions, updateContactStage };
};
